import { createTranslations } from '@npco/common-utils-translations'

export const createSavingsAccountFormTranslations = createTranslations({
  errorActivating: "Zeller Savings Account couldn't be activated.",
  activationSuccess: 'Zeller Savings Account successfully activated',
})
